<template>
  <b-modal ref="modalRef" hide-footer size="lg" title="Information">
    <ul>
      <li v-for="(item, index) in data" :key="index">
        £{{ item.amount }} -> {{ item.location }}
      </li>
    </ul>
    <b-button variant="danger" @click="hide">Close</b-button>
  </b-modal>
</template>

<script>
export default {
  props: {
    data: {
      required: true
    }
  },
  methods: {
    show() {
      this.$nextTick(() => {
        this.$refs.modalRef.show();
      });
    },
    hide() {
      this.$nextTick(() => {
        this.$refs.modalRef.hide();
      });
    }
  }
};
</script>
